import React, { useMemo } from 'react';
import FlipMove from "react-flip-move";
import { useProjectForm } from "../../../providers/ProjectFormProvider";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';

const ProjectIndustries = props => {

    const { formModel: project, isProjectUpdating } = useProjectForm();


    const selectIndustry = async (industry) => {

        let industries = [...(project.industries || [])];


        if (industry.importance !== undefined) {
            if (TB.find(industries, ['id', parseInt(industry.id)])) {
                industries = TB.map(industries, model => {
                    if (model.id === industry.id) {
                        return { ...industry };
                    }
                    return model;
                });
            } else {
                industries.push(industry);
            }

        } else {
            industries = TB.xorBy(industries, [industry], 'id');
        }
        industries = TB.map(industries, industryy => ({ ...industryy, importance: parseInt(industryy.importance) }))

        return props.onChange({ industries })
    }
    const available = TB.map(laravel.client_industries, (name, id) => ({ name, id: parseInt(id) }));


    const selectedIds = useMemo(() => {
        return TB.map(project.industries || [], 'id')
    }, [
        project?.industries
    ]);

    const allIndustries = useMemo(() => {
        let industries = TB.map(available || [], industry => {
            if (selectedIds.includes(parseInt(industry.id))) {
                return TB.find(project.industries, ['id', parseInt(industry.id)]);
            }

            return TB.pick(industry, ['id', 'name', 'type', 'type_name', 'is_extra']);
        })

        return TB.orderBy(industries || [], [
            industry => selectedIds.includes(industry?.id) ? selectedIds.indexOf(industry.id) : 1000,
            industry => selectedIds.includes(industry?.id),
        ], ['asc', 'asc'])
    }, [
        selectedIds,
        available
    ]);

    return (
        <div className="flex flex-col gap-6">
            {project.industries?.length >= 10 && (
                <div className="flex flex-col justify-start items-start self-stretch relative gap-4">
                    {/*<p className="self-stretch text-lg font-medium text-left text-black">*/}
                    {/*    Industry Experience Chosen*/}
                    {/*</p>*/}

                    <div className="invalid-feedback flex text-muted">
                        Max limit reached for industry experience
                    </div>
                </div>
            )}
            <div className="discipline-skills-container skill-importance-container relative gap-3">

                <FlipMove typeName={null} maintainContainerHeight={true}>
                    {TB.map(allIndustries, industry => {
                        return (
                            <div key={industry.id}>
                                <NEWSkillFormButton
                                    valuePropName={'importance'}
                                    disabled={props.isDisabled || isProjectUpdating}
                                    scoringOptions={laravel.importance_levels}
                                    skill={industry}
                                    selected={selectedIds.includes(industry?.id)}
                                    onChange={selectIndustry}
                                    className="min-w-[115px]"
                                />
                            </div>
                        )
                    })}
                </FlipMove>
            </div>
        </div>
    );
};

ProjectIndustries.propTypes = {};

export default ProjectIndustries;